// Google Analytics Configuration
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = 'G-N1QTX2511D';

// Instructions for setting up Google Analytics:
// 1. Go to https://analytics.google.com/
// 2. Create a new property for your website
// 3. Get your Measurement ID (starts with 'G-')
// 4. Replace 'G-XXXXXXXXXX' above with your actual Measurement ID
// 5. The tracking will automatically respect user cookie preferences

// Note: Users must accept analytics cookies for tracking to work
// This ensures GDPR/privacy compliance